import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios'
import eventHub from '../helpers/event-hub'
import scrollTo from '../directives/scrollTo'
import showOnScroll from '../directives/showOnScroll'

if (document.getElementById('vue-main')) {
  new Vue({
    mixins: [],
    el: '#vue-main',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json`,
        email: '',
        allowRegister: false,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        isSent: false,
        //Members
        apiMemberUrl: `${location.origin}/wp-json/wp/v2/member/`,
        apiCategoriesUrl: `${location.origin}/wp-json/wp/v2/member_categories`,
        loading: {
          form: false,
          members: false,
        },
        members: [],
        offset: 0,
        categories_members: [],
        posts_per_page: 12,
        total: 0,
        filters: {}
      }
    },
    computed: {
      hasMore() {
        return this.total > this.members.length;
      }
    },
    mounted() {
      if (document.querySelector('.VueCarousel-slide')) {
        document.querySelector('.VueCarousel-slide').classList.add('VueCarousel-slide-active')
      }
      // this.getCategoriesMembers()
    },
    components: {
      Carousel,
      Slide
    },
    methods: {
      // Contact Form
      onSuccess(event) {
        eventHub.$emit('toast:info', {
          title: 'C\'est envoyé !',
          content: 'OPEO a bien reçu votre demande.',
          autoleave: true
        })
        if (event['inscription_a_la_newsletter'] && event['email']) {
          this.registerUserToNewsletter(event)
        }
        this.isSent = true
      },
      registerUserToNewsletter(event) {
        const data = new FormData
        data.append('email', event.email)
        axios.post(`${this.apiUrl}/mailchimp/v1/register`, data, { headers: this.headers })
      },
      onError() {
        eventHub.$emit('toast:danger', {
          title: 'Oups !',
          content: 'Désolé. Certains champs semblent manquants ou mal renseignés.',
          autoleave: true
        })
      },
      // Newsletter Fomr
      register() {
        if (this.allowRegister) {
          this.loading.form = true
          const data = new FormData
          data.append('email', this.email)
          axios
            .post(`${this.apiUrl}/mailchimp/v1/register`, data, { headers: this.headers })
            .then(() => {
              this.email = ''
              this.allowRegister = false
              eventHub.$emit('toast:info', {
                title: 'Bienvenue !',
                content: 'OPEO vous remercie pour votre inscription.',
                autoleave: true
              })
            })
            .catch(error => {
              const response = error.response
              if (response.status == 400) {
                eventHub.$emit('toast:warning', {
                  title: 'Oups !',
                  content: response.data.data ? 'Vous semblez déjà inscrit(e) sur notre liste de diffusion.' : 'Le format d\'email semble erroné.',
                  autoleave: true
                })
              } else {
                eventHub.$emit('toast:danger', {
                  title: 'Oups !',
                  content: 'Nous n\'avons pas pu vous inscrire sur notre liste, merci de réessayer ultérieurement',
                  autoleave: true
                })
              }
            })
            .then(() => {
              this.loading.form = false
            })
        }
      },

      // Video Modal
      openVideoModal(name) {
        eventHub.$emit(`modal:${name}:open`)
      },

      // Members
      // getCategoriesMembers() {
      //   axios
      //     .get(this.apiCategoriesUrl, {
      //       params: {
      //         lang: document.getElementById('vue-main').dataset.lang
      //       }
      //     })
      //     .then(response => {
      //       this.categories_members = this.categories_members.concat(response.data);
      //       this.filters.category = response.data[0].id
      //       this.getMembers()
      //     });
      // },
      // getMembers() {
      //   this.loading.members = true
      //   let paramsMembers = {
      //     per_page: 6,
      //     lang: document.getElementById('vue-main').dataset.lang
      //   }

      //   if (this.filters.category) {
      //     paramsMembers = {
      //       member_categories: this.filters.category,
      //       per_page: 6,
      //       lang: document.getElementById('vue-main').dataset.lang
      //     }
      //   }
      //   axios
      //     .get(this.apiMemberUrl, {
      //       params: paramsMembers
      //     })
      //     .then(response => {
      //       this.members = this.members.concat(response.data);
      //       this.loading.members = false;
      //       this.totalPages = response.headers['x-wp-totalpages']
      //     });
      // },
      // getMemberThumbnail(member, size) {
      //   return member.acf.photo.sizes[size]
      // },
      updateCategory(category) {
        this.members = []
        this.offset = 0
        this.filters.category = category
        this.getMembers()
      },
      // Modal
      onCloseModal() {
        let video = document.getElementById('video');
        video.pause()
      }
    },
    directives: {
      scrollTo,
      showOnScroll
    },
  })
}